module.exports = __webpack_public_path__ + "img/banner-5.516ac0b5.jpg";